import { css } from "@emotion/react";
import { ThemeUI } from "../../../theme";

type Props = { theme: ThemeUI; isActive?: boolean; isOpen?: boolean };

export const root = css`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;

export const title = ({ theme }: Props) => css`
  padding: 0 10px 10px;
  width: 100%;
  box-sizing: border-box;

  & > div {
    display: block;
    width: 100%;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 11px;
    line-height: 14px;
    color: ${theme.palette.secondary30};
    white-space: normal;
    word-break: normal;
  }
`;

export const list = css`
  margin: 0;
  padding: 0;
  list-style: none;
  width: 100%;
`;

export const subList = css`
  margin: 6px 0 12px;
  padding: 6px;
  list-style: none;
  background: #f7f8fb;
  border-radius: 12px;
`;

export const linkStyle = ({ theme, isActive }: Props) => css`
  color: ${isActive ? "#001740" : theme.palette.secondary90};
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  padding: 11px 12px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px;
  cursor: pointer;
  font-weight: ${isActive ? 700 : 500};
  background: ${isActive ? "#eef5ff" : "transparent"};
  border: 1px solid ${isActive ? "#dbeafe" : "transparent"};

  &:hover {
    background: #f2f6ff;
    color: #001740;
  }

  & svg {
    fill: ${isActive ? "#001740" : theme.palette.primary};
    min-width: 18px;
    flex-shrink: 0;
  }
`;

export const item = ({ theme, isActive }: Props) => css`
  margin-bottom: 4px;
  width: 100%;

  & a {
    ${linkStyle({ theme, isActive })}
  }

  &::marker {
    content: "";
  }
`;

export const details = css`
  margin-bottom: 4px;
  width: 100%;

  &[open] summary {
    background: #f2f6ff;
    color: #001740;
  }

  summary {
    list-style: none;
  }

  summary::-webkit-details-marker {
    display: none;
  }
`;

export const summary = ({ theme, isActive }: Props) => css`
  ${linkStyle({ theme, isActive })}

  justify-content: space-between;

  .summary-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .chevron {
    font-size: 14px;
    color: #94a3b8;
    transition: transform 0.2s ease;
  }

  details[open] & .chevron {
    transform: rotate(90deg);
  }
`;

export const subItem = ({ isActive }: Props) => css`
  margin-bottom: 2px;

  & a {
    display: flex;
    align-items: center;
    text-decoration: none;
    border-radius: 10px;
    padding: 9px 10px 9px 14px;
    color: ${isActive ? "#001740" : "#475569"};
    font-weight: ${isActive ? 700 : 500};
    background: ${isActive ? "#ffffff" : "transparent"};
    box-shadow: ${isActive ? "0 4px 12px rgba(15, 23, 42, 0.06)" : "none"};

    &:hover {
      background: #ffffff;
      color: #001740;
    }
  }
`;